import React from 'react';

const PrevIcon = () => (
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8318 1.66333C11.8318 1.82365 11.7516 2.00401 11.6314 2.12425L3.75563 10L11.6314 17.8758C11.7516 17.996 11.8318 18.1764 11.8318 18.3367C11.8318 18.497 11.7516 18.6774 11.6314 18.7976L10.6294 19.7996C10.5091 19.9198 10.3288 20 10.1685 20C10.0081 20 9.82777 19.9198 9.70753 19.7996L0.368858 10.4609C0.248617 10.3407 0.168457 10.1603 0.168457 10C0.168457 9.83968 0.248617 9.65932 0.368858 9.53908L9.70753 0.200401C9.82777 0.0801603 10.0081 0 10.1685 0C10.3288 0 10.5091 0.0801603 10.6294 0.200401L11.6314 1.2024C11.7516 1.32265 11.8318 1.48297 11.8318 1.66333Z" fill="white" />
    </svg>
);

export default PrevIcon;
